import React from 'react';
import { bool, func } from 'prop-types';

import { Row, Col, Button } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

import { useStockBuySellContext } from '../../hooks';
import { useEventTracker } from '../../../tracker';
import useAmendEventTracker from '../../../StockAmend/tracker';
import OrderSummaryTop from './OrderSummaryTop';
import OrderSummaryBottom from './OrderSummaryBottom';
import OrderNotes from './OrderNotes';

const PopUpConfirmation = (props) => {
  const { show, onHide, onConfirm, isLoadingSubmit } = props;

  const { code, isCreate, isAmend, isBuy, isSell, isLimitOrder, isAutoOrder } =
    useStockBuySellContext();

  const { eventClickConfirmBuy, eventClickConfirmSell } = useEventTracker();
  const { eventClickConfirmAmend } = useAmendEventTracker();

  const getTitle = () => {
    switch (true) {
      case !isAmend && isBuy:
        return 'Konfirmasi Pembelian';
      case !isAmend && isSell:
        return 'Konfirmasi Penjualan';
      case isAmend:
        return 'Konfirmasi Perubahan';
      default:
        return 'Konfirmasi';
    }
  };

  const handleConfirmBuy = () => {
    eventClickConfirmBuy();
    onConfirm();
  };

  const handleConfirmSell = () => {
    eventClickConfirmSell();
    onConfirm();
  };

  const handleConfirmAmend = () => {
    eventClickConfirmAmend();
    onConfirm();
  };

  return (
    <PopUpCenterV2
      size="md"
      show={show}
      onHide={onHide}
      title={getTitle()}
      data-testid="popup-confirmation"
    >
      <OrderSummaryTop code={code} />
      <OrderSummaryBottom />
      <OrderNotes />
      {/* TODO: Uncomment this later */}
      {/* {isCreate && isBuy && (
        <Button
          fluid
          variant="primary"
          size="lg"
          loading={isLoadingSubmit}
          onClick={handleConfirmBuy}
          data-testid="btn-confirmBuy"
        >
          {isLimitOrder && 'Beli'}
          {isAutoOrder && 'Simpan Auto Order Buy'}
        </Button>
      )}
      {isCreate && isSell && (
        <Button
          fluid
          variant="danger"
          size="lg"
          loading={isLoadingSubmit}
          onClick={handleConfirmSell}
          data-testid="btn-confirmSell"
        >
          {isLimitOrder && 'Jual'}
          {isAutoOrder && 'Simpan Auto Order Sell'}
        </Button>
      )}
      {isAmend && (
        <Button
          fluid
          variant="primary"
          size="lg"
          loading={isLoadingSubmit}
          onClick={handleConfirmAmend}
          data-testid="btn-confirmAmend"
        >
          Simpan
        </Button>
      )} */}
      {/* TODO: Remove this later */}
      <Row align="between" gutters={8}>
        <Col size={6}>
          {isCreate && isBuy && (
            <Button fluid variant="primary" size="lg" onClick={onHide}>
              Batalkan
            </Button>
          )}
          {isCreate && isSell && (
            <Button fluid variant="danger" size="lg" onClick={onHide}>
              Batalkan
            </Button>
          )}
          {isAmend && (
            <Button fluid variant="primary" size="lg" onClick={onHide}>
              Batalkan
            </Button>
          )}
        </Col>
        <Col size={6}>
          {isCreate && isBuy && (
            <Button
              fluid
              variant="secondary"
              size="lg"
              loading={isLoadingSubmit}
              onClick={handleConfirmBuy}
              data-testid="btn-confirmBuy"
            >
              {isLimitOrder && 'Beli'}
              {isAutoOrder && 'Simpan Auto Order Buy'}
            </Button>
          )}
          {isCreate && isSell && (
            <Button
              fluid
              variant="danger-outline"
              size="lg"
              loading={isLoadingSubmit}
              onClick={handleConfirmSell}
              data-testid="btn-confirmSell"
            >
              {isLimitOrder && 'Jual'}
              {isAutoOrder && 'Simpan Auto Order Sell'}
            </Button>
          )}
          {isAmend && (
            <Button
              fluid
              variant="secondary"
              size="lg"
              loading={isLoadingSubmit}
              onClick={handleConfirmAmend}
              data-testid="btn-confirmAmend"
            >
              Simpan
            </Button>
          )}
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpConfirmation.propTypes = {
  show: bool,
  onHide: func,
  onConfirm: func,
  isLoadingSubmit: bool,
};

PopUpConfirmation.defaultProps = {
  show: false,
  onHide: () => {},
  onConfirm: () => {},
  isLoadingSubmit: false,
};

export default PopUpConfirmation;
